import { CalendarGrid } from './CalendarGrid';
import { CalendarHeader } from './CalendarHeader';

export function Calendar() {
  return (
    <div className="grid gap-2">
      <CalendarHeader />
      <div className="bg-neutrals-100 rounded-xl">
        <CalendarGrid />
      </div>
    </div>
  );
}
